import { createSlice } from "@reduxjs/toolkit";

const languageSlice = createSlice({
  name: "languageSlice",
  initialState: {
    language: "ch",
    applicationFee: "",
    consultationPath : '',
    paymentDetails: null,
    triggerOmise: null,
    languageList: [
      { code: "ch", label: "Traditional Chinese" },
      { code: "sch", label: "Simplified Chinese" },
      { code: "en", label: "English" },
      { code: "vn", label: "Vietnamese" },
      { code: "kr", label: "Korean" },
    ],
  },
  reducers: {
    toggleLanguage: (state, action) => {
      console.log("state.language ", action);

      state.language = action.payload
    },
    consultationPath: (state, action) => {
      state.consultationPath = action.payload;
    },
    applicationFee: (state, action) => {
      state.applicationFee = action.payload;
    },
    paymentDetails: (state, action) => {
      state.paymentDetails = action.payload;
    },
    triggerOmise: (state, action) => {
      state.triggerOmise = action.payload;
    },
  },
});

export const { actions, reducer } = languageSlice;
